import { Component, Inject, OnInit, ViewChild } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatProgressBar } from '@angular/material/progress-bar'
import { ApiService, Currencies, PriceModel, ProductModel, ProgressIndicatorService } from '@mmx/shared'
import { extend } from 'lodash'

@Component({
  selector: 'mmx-product-price-dialog-component',
  templateUrl: './product-price-dialog.component.html',
  standalone: false,
})
export class ProductPriceDialogComponent implements OnInit {
  @ViewChild(MatProgressBar) progressBar: MatProgressBar

  product: ProductModel
  price: PriceModel
  title: string
  currencies = Currencies
  errors: any
  productData: UntypedFormGroup
  productCodes: string[] = []

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ProductPriceDialogComponent>,
    private fb: UntypedFormBuilder,
    private progressService: ProgressIndicatorService,
    private pmService: ApiService,
  ) {
    this.product = this.data.product
    this.title = this.data.price ? 'Update Product Price' : 'Add Product Price'
    this.price = new PriceModel(
      extend(
        {
          productId: this.product.id,
          priceCurrency: 'USD',
        },
        this.data.price ? this.data.price.toJSON() : {},
      ),
    )
  }

  ngOnInit() {
    this.productCodes = this.product.getCPTCodes()
    this.productData = this.fb.group({
      code: this.fb.control(this.price.code, Validators.required),
      price: this.fb.control(this.price.price, [Validators.required]), // Validators.pattern('^[0-9]+\.[0-9]{2}$')]),
      priceCurrency: this.fb.control(
        { value: this.price.priceCurrency, disabled: true },
        Validators.required,
      ),
      carriers: this.fb.control(this.price.requirements.carrierLookups || []),
    })

    if (this.productCodes.length === 1) {
      this.productData.get('code').setValue(this.productCodes[0])
      this.productData.get('code').disable()
      this.productData.updateValueAndValidity()
    }
  }

  getErrorMessage(controlName: string) {
    if (this.productData.get(controlName).hasError('pattern')) {
      return 'Invalid price.'
    } else {
      return 'This field is required'
    }
  }

  onSubmit() {
    this.price.code = this.productData.get('code').getRawValue()
    this.price.price = this.productData.value.price
    this.price.priceCurrency = this.price.priceCurrency // while is not available all currencies
    this.price.requirements = {}

    if (
      this.productData.value.carriers &&
      this.productData.value.carriers.length > 0
    ) {
      this.price.requirements.carrierLookups =
        this.productData.value.carriers.map((c) => {
          return typeof c === 'string' ? c : c.lookupId || c.id
        })
    }

    this.progressBar.mode = 'indeterminate'

    if (this.price.id) {
      this.pmService.updateProductPrice(this.price.toJSON()).subscribe(
        () => {
          this.progressService.snack('Product updated successfully')
          this.dialogRef.close(this.price)
        },
        (err) => {
          this.progressBar.mode = 'determinate'
          if (err.error) {
            this.errors = err.error.errors
          } else {
            this.progressService.snack(
              'An error occurred while updating product price. Please try again',
            )
          }
        },
      )
    } else {
      this.pmService.createProductPrice(this.price.toJSON()).subscribe(
        (resp) => {
          this.progressService.snack('Product created successfully')
          this.price.id = resp.data.id
          this.dialogRef.close(this.price)
        },
        (err) => {
          this.progressBar.mode = 'determinate'
          if (err.error) {
            this.errors = err.error.errors
          } else {
            this.progressService.snack(
              'An error occurred while creating product price. Please try again',
            )
          }
        },
      )
    }
  }
}
